import SafeLink from "modules/components/SafeLink";

interface IProps {
  content: string;
}

function AddLinkFromContent(props: IProps) {
  const { content } = props;

  if (!content) {
    return null;
  }
  const regex = /\[(.*?)\]/;
  // Get Content B/W [____] -> Ex -  [OEM#oem-parts]  After # is link.
  const result = content.split(regex);

  return (
    <>
      {result.map((eachContent: string, index: number) => {
        const findLink = eachContent.split("#");
        if (findLink.length > 1) {
          return (
            <SafeLink href={findLink[1]} key={`${findLink[1]}-${index}`}>
              {findLink[0]}
            </SafeLink>
          );
        }
        return eachContent;
      })}
    </>
  );
}

export default AddLinkFromContent;
